import { Box, Center, Flex, Tag, Text, SkeletonText } from '@chakra-ui/react';

import { v4 as uuidv4 } from 'uuid';

import PropTypes from 'prop-types';
import { ReducerStatus } from 'utils/constants';
import IdTag from 'components/common/fields/IdTag';
import EmailGroup from 'components/common/fields/EmailGroup';
import { removeHtmlTags } from 'utils/textParser';

function SubQuestDetails({ getStatus, subQuest, ...rest }) {
  return (
    <Flex
      direction="column"
      borderWidth="1px"
      borderRadius="md"
      p={4}
      gap={4}
      {...rest}
    >
      <SkeletonText
        noOfLines={2}
        isLoaded={
          getStatus !== ReducerStatus.LOADING &&
          getStatus !== ReducerStatus.FAILED
        }
      >
        <Flex align="center" gap={2}>
          <IdTag id={subQuest?.id} />
          <Text fontSize="2xl" fontWeight={500}>
            {subQuest?.name} ({subQuest?.type.name})
          </Text>
        </Flex>

        <Flex align="center">
          {subQuest?.tags &&
            Array.isArray(JSON.parse(subQuest?.tags)) &&
            JSON.parse(subQuest.tags).map((tag) => (
              <Tag key={uuidv4()} m={2} color="teal" size="sm">
                <Center>{tag.toUpperCase()}</Center>
              </Tag>
            ))}
        </Flex>
      </SkeletonText>

      <SkeletonText
        noOfLines={4}
        isLoaded={
          getStatus !== ReducerStatus.LOADING &&
          getStatus !== ReducerStatus.FAILED
        }
      >
        <Text fontSize="sm">{removeHtmlTags(subQuest?.objective)}</Text>
      </SkeletonText>

      <SkeletonText
        noOfLines={2}
        isLoaded={
          getStatus !== ReducerStatus.LOADING &&
          getStatus !== ReducerStatus.FAILED
        }
      >
        <Text fontSize="xs" fontWeight={500}>
          Owner: {subQuest?.owner?.name || 'N/A'}
        </Text>

        {subQuest?.code && (
          <Text fontSize="xs" fontWeight={500}>
            Code: {subQuest?.code}
          </Text>
        )}
      </SkeletonText>

      <SkeletonText
        noOfLines={5}
        isLoaded={
          getStatus !== ReducerStatus.LOADING &&
          getStatus !== ReducerStatus.FAILED
        }
      >
        {subQuest?.ownerGroups && (
          <Box fontSize="xs">
            <EmailGroup name="Contributors: " emails={subQuest?.ownerGroups} />
          </Box>
        )}
      </SkeletonText>
    </Flex>
  );
}

SubQuestDetails.defaultProps = {
  subQuest: null,
};

SubQuestDetails.propTypes = {
  getStatus: PropTypes.string.isRequired,
  subQuest: PropTypes.object,
};

export default SubQuestDetails;
